export const activity = {
  log: {
    title: "Change log - #{{id}}",
    context: "Context",
    changes: "Changes",
    subject: "Subject",
    subjectType: "Subject type",
    subjectIds: "Subject Ids",
    event: "Event",
    description: "Description",
    date: "Date",
    causedBy: "Caused by",
    requestedBy: "Requested by",
    currentState: "Current state",
  },
  event: "Event",
  subject: "Subject",
  subjectType: "Subject Type",
  staticState: {
    created: "Created",
    updated: "Updated",
    deleted: "Deleted",
    restore: "Restored",
    restored: "Restored",
    batch: {
      updated: "Batch updated",
      deleted: "Batch deleted",
      restore: "Batch restored",
    },
    import: {
      created: "Import created",
      updated: "Import updated",
    },
  },
};
